// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Enseignantes from "layouts/enseignantes";
import Home from "layouts/home";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import SettingsIcon from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";
import ProtectedRoute from "ProtectedRoute";
import MapPage from "layouts/map";
import Affectations from "layouts/affectations";
import Register from "layouts/register";
import ChangePassword from "layouts/changepassword";
import EstablishmentMapPage from "layouts/newmap/EstablishmentMapPage";
import TeacherDistributionMapPage from "layouts/newmap/TeacherDistributionMapPage";
import TeacherHistory from "layouts/teacherhistory";
import TeacherDetail from "layouts/teacher-detail";
import Statistics from "layouts/statistics";
import LeaveRequests from "layouts/leave-requests";
import Recruiters from "layouts/recruiters";
import Notifications from "layouts/notifications";
import EstablishmentAttendanceReport from "layouts/establishment-attendance";
import AreaAttendanceSummary from "layouts/area-attendance-summary";
import SettingsPage from "layouts/settings";
import EstablishmentsPage from "layouts/establishments";
import TeacherLicense from "layouts/teacher-license";
import AssistantPage from "layouts/assistant";


const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    nameKey: "nav.dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Cube size="12px" />,
    component: <ProtectedRoute><Dashboard /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Assistant",
    nameKey: "nav.assistant",
    key: "assistant",
    route: "/assistant",
    icon: <SpaceShip size="12px" />,
    component: <ProtectedRoute><AssistantPage /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: false
  },
  {
    type: "collapse",
    name: "Accueil",
    nameKey: "nav.home",
    key: "accueil",
    route: "/accueil",
    icon: <Shop size="12px" />,
    component: <ProtectedRoute><Home /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Personnel",
    nameKey: "nav.teachers",
    key: "enseignantes",
    route: "/enseignantes",
    icon: <Cube size="12px" />,
    component: <ProtectedRoute><Enseignantes /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Licences du personnel",
    nameKey: "nav.teacher_license",
    key: "teacher-license",
    route: "/teacher-license",
    icon: <Document size="12px" />,
    component: <ProtectedRoute><TeacherLicense /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Map",
    key: "map",
    route: "/map",
    icon: <Cube size="12px" />,
    component: <ProtectedRoute><MapPage /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: false
  },
  {
    type: "collapse",
    name: "Voir tous les établissements",
    nameKey: "nav.view_establishments_map",
    key: "tout-voir-establishment",
    route: "/tout-voir-establishment",
    icon: <Office size="12px" />,
    component: <ProtectedRoute><EstablishmentMapPage /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: false
  },
  {
    type: "collapse",
    name: "Carte du personnel",
    nameKey: "nav.teacher_map",
    key: "teacher-distribution-map",
    route: "/carte-enseignants",
    icon: <Office size="12px" />,
    component: <ProtectedRoute><TeacherDistributionMapPage /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Affectations",
    nameKey: "nav.affectations",
    key: "affectations",
    route: "/affectations",
    icon: <Office size="12px" />,
    component: <ProtectedRoute><Affectations /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Établissements",
    nameKey: "nav.establishments",
    key: "establishments",
    route: "/establishments",
    icon: <Office size="12px" />,
    component: <ProtectedRoute><EstablishmentsPage /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Statistiques",
    nameKey: "nav.statistics",
    key: "statistiques",
    route: "/statistiques",
    icon: <SettingsIcon size="12px" />,
    component: <ProtectedRoute><Statistics /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Gestion des utilisateurs",
    nameKey: "nav.users",
    key: "gestion-utilisateurs",
    route: "/gestion-utilisateurs",
    icon: <CustomerSupport size="12px" />,
    component: <ProtectedRoute><Register /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Demandes de congé",
    nameKey: "nav.leave_requests",
    key: "leave-requests",
    route: "/leave-requests",
    icon: <Document size="12px" />,
    component: <ProtectedRoute><LeaveRequests /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Recruteurs",
    nameKey: "nav.recruiters",
    key: "recruiters",
    route: "/recruiters",
    icon: <CustomerSupport size="12px" />,
    component: <ProtectedRoute><Recruiters /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Synthèse présence zone",
    nameKey: "nav.area_attendance",
    key: "area-attendance-summary",
    route: "/synthese-presence-zone",
    icon: <SettingsIcon size="12px" />,
    component: <ProtectedRoute><AreaAttendanceSummary /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Rapport présence établissement",
    nameKey: "nav.establishment_attendance",
    key: "establishment-attendance",
    route: "/rapport-presence-etablissement",
    icon: <Document size="12px" />,
    component: <ProtectedRoute><EstablishmentAttendanceReport /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Notifications",
    nameKey: "nav.notifications",
    key: "notifications",
    route: "/notifications",
    icon: <Document size="12px" />,
    component: <ProtectedRoute><Notifications /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Paramètres",
    nameKey: "nav.settings",
    key: "parametres",
    route: "/parametres",
    icon: <SettingsIcon size="12px" />,
    component: <ProtectedRoute><SettingsPage /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: true
  },
  {
    type: "collapse",
    name: "Changer le mot de passe",
    nameKey: "nav.change_password",
    key: "changer-mot-de-passe",
    route: "/changer-mot-de-passe",
    icon: <CustomerSupport size="12px" />,
    component: <ProtectedRoute><ChangePassword /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: false
  },
  {
    type: "collapse",
    name: "Histoire du personnel",
    nameKey: "nav.teacher_history",
    key: "histoire-des-enseignants",
    route: "/histoire-des-enseignants/:id",
    icon: <CustomerSupport size="12px" />,
    component: <ProtectedRoute><TeacherHistory /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: false
  },
  {
    type: "collapse",
    name: "Fiche membre du personnel",
    nameKey: "nav.teacher_detail",
    key: "enseignant-detail",
    route: "/enseignant/detail",
    icon: <CustomerSupport size="12px" />,
    component: <ProtectedRoute><TeacherDetail /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: false
  },
  {
    type: "collapse",
    name: "Fiche membre du personnel",
    nameKey: "nav.teacher_detail",
    key: "enseignant",
    route: "/enseignant/:id",
    icon: <CustomerSupport size="12px" />,
    component: <ProtectedRoute><TeacherDetail /></ProtectedRoute>,
    noCollapse: true,
    showInSideBar: false
  },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   route: "/tables",
  //   icon: <Office size="12px" />,
  //   component: <Tables />,
  //   noCollapse: true,
  //   showInSideBar: true
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   route: "/billing",
  //   icon: <CreditCard size="12px" />,
  //   component: <Billing />,
  //   noCollapse: true,
  //   showInSideBar: true
  // },
  // {
  //   type: "collapse",
  //   name: "Virtual Reality",
  //   key: "virtual-reality",
  //   route: "/virtual-reality",
  //   icon: <Cube size="12px" />,
  //   component: <VirtualReality />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   route: "/rtl",
  //   icon: <Settings size="12px" />,
  //   component: <RTL />,
  //   noCollapse: true,
  // },
  // { type: "title", title: "Account Pages", key: "account-pages" },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   route: "/profile",
  //   icon: <CustomerSupport size="12px" />,
  //   component: <Profile />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Sign In",
    nameKey: "nav.sign_in",
    key: "sign-in",
    route: "/sign-in",
    icon: <Document size="12px" />,
    component: localStorage.getItem("tk446655440000")
    ? <ProtectedRoute><Dashboard /></ProtectedRoute>
    : <SignIn />,
    noCollapse: false,
    showInSideBar: false
  },
  {
    type: "collapse",
    name: "Sign Up",
    nameKey: "nav.sign_up",
    key: "sign-up",
    route: "/sign-up",
    icon: <SpaceShip size="12px" />,
    component: localStorage.getItem("tk446655440000")
    ? <ProtectedRoute><Dashboard /></ProtectedRoute>
    : <SignUp />,
    noCollapse: true,
    showInSideBar: false
  },
];

export default routes;

